import {
  LoanPurpose,
  QuestionSetSlug,
  SimpleV2ReasonCode,
} from '@mortgage-pos/types'
import { getCSRFToken } from '@mortgage-pos/utils/tokens'
import incense from '@mortgage-pos/ui/incense'
import { cohesionHeaders } from '../services/http'
import { environment } from '../../environments/environment'

export function persistOffRampReason(
  applicationGuid: string,
  offrampReasonCode: SimpleV2ReasonCode
): Promise<void> {
  const url = `${environment.apiBaseUrl}/api/persist-offramp-reason`
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...cohesionHeaders(),
      csrf: getCSRFToken(),
    },
    body: JSON.stringify({ applicationGuid, offrampReasonCode }),
    keepalive: true,
    credentials: 'include',
  })
    .then((res) => {
      if (!res.ok) throw new Error(`persistOffRampReason failed: ${res.status}`)
    })
    .catch((error) => {
      console.error('persistOffRampReason failed:', error)
      incense(error)
        .details({
          name: 'PersistOffRampReasonError',
          message: 'Failed to persist off-ramp reason',
        })
        .error()
    })
}

export function buildAlfiePrePricingSlug(
  loanPurpose: LoanPurpose | undefined,
  questionSetSlug?: string | null
): QuestionSetSlug {
  if (loanPurpose === LoanPurpose.Refinance) {
    return QuestionSetSlug.PrePricingRefinance
  }
  if (
    questionSetSlug === QuestionSetSlug.SimpleV2Refinance ||
    questionSetSlug === QuestionSetSlug.SimpleV2RefinanceFannie
  ) {
    return QuestionSetSlug.PrePricingRefinance
  }
  return QuestionSetSlug.PrePricingPurchase
}

export function buildBorrowerPortalContinueUrl(): string {
  return environment.borrowerPortal.uiBaseUrl
}
